<template>
  <v-card>
    <v-card-title class="pb-0">
      <h1 class="headline">
        Загрузка Описание товаров
      </h1>
    </v-card-title>
    <v-card-text class="pt-2">
      <input
        id="file-dialog"
        type="file"
        @change="handleFiles"
      >
      <v-spacer />
      <v-btn
        color="primary"
        small
        class="my-0"
        :loading="fileLoading"
        @click="openFileOption"
      >
        Выбрать файл
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { importGoodsFile } from "../../../backend/importApi.js";
import { importResult } from "./import-result.js";

export default {
  data() {
    return {
      fileLoading: false,
    };
  },
  methods: {
    openFileOption() {
      var inputElement = document.getElementById("file-dialog");
      inputElement.click();
    },
    handleFiles(ev) {
      this.fileLoading = true;
      const file = ev.target.files[0];

      const reader = new FileReader();

      reader.onload = (e) => {
        var arrayBuffer = e.target.result;
        var array = Array.from(new Uint8Array(arrayBuffer));

        this.import({ originName: file.name, data: array, type: 1 });
      };
      if (file) {
        reader.readAsArrayBuffer(file);
      } else {
        this.fileLoading = false;
      }
    },
    async import(fileInfo) {
      this.fileLoading = true;
      const result = await importGoodsFile(fileInfo);
      if (this.fileLoading) {
        this.showInfo(
          "Импорт описания товаров займет какое-то время. Пожалуйста, подождите.",
        );
      }
      if (!result) {
        this.fileLoading = false;
        return;
      }

      switch (result) {
        case importResult.FULLIMPORT:
          this.showInfo("Описание товаров импортированы в справочник");
          break;
        case importResult.PARTLYIMPORT:
          this.showInfo(
            "Описания товаров импортированы в справочник частично, ошибки можно обработать в черновике",
          );
          this.$router.push({ name: "goods-drafts" });
          break;
        case importResult.NOTIMPORT:
          this.showInfo(
            "Описания товаров не импортированы в справочник, ошибки можно обработать в черновике ",
          );
          this.$router.push({ name: "goods-drafts" });
          break;
      }
      this.fileLoading = false;
    },
  },
};
</script>

<style>
#file-dialog {
  display: none;
}
</style>
